import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const RWABucksSection = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const boxes = sectionRef.current.querySelectorAll('.royalty-box')
    gsap.set(boxes, { opacity: 0, y: 40 })

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        gsap.to(boxes, {
          opacity: 1,
          y: 0,
          duration: 0.8,
          stagger: 0.2,
          ease: 'power3.out',
        })
      }
    })

    return () => ScrollTrigger.getAll().forEach(t => t.kill())
  }, [])

  return (
    <section className="rwa-bucks-section" ref={sectionRef}>
      <div className="alignment-wrapper">
        <h2 className="rwa-heading">RWA Tickets and Royalties</h2>
        <p className="rwa-subtext">
          RWA Tickets are digital assets purchased by Backers to support campaigns and earn royalties.
          There are two types of Tickets with distinct royalty structures:
        </p>

        <div className="rwa-layout">
          <div className="rwa-left">
            <div className="rwa-image" />
          </div>

          <div className="rwa-right">
            <div className="royalty-box">
              <h4 className="royalty-title">Unspent Tickets</h4>
              <p className="royalty-desc">
                Track <strong>20% of royalties</strong> from all Founders’ campaigns on the platform.
              </p>
            </div>
            <div className="royalty-box">
              <h4 className="royalty-title">Spent Tickets</h4>
              <p className="royalty-desc">
                Track <strong>80% of royalties</strong> from the specific campaign they are spent on.
              </p>
            </div>
            <div className="royalty-box">
              <h4 className="royalty-title">Additional Earnings</h4>
              <p className="royalty-desc">
                Both Spent and Unspent Tickets earn <strong>Crypto Commissioner NFT royalties</strong> on top of campaign royalties.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default RWABucksSection
